import { Link } from 'react-router-dom';
import * as Avatar from '@givebutter/primitives/avatar';
import { Box } from '@givebutter/primitives/box';
import { maskDecimal } from '@givebutter/util';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Drawer from 'components/drawer';
import { useCurrencySymbol } from 'customHooks/useCurrencySymbol';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentMailing } from 'customHooks/useCurrentMailing';
import { rawDateFromServer } from 'helpers/dates';
import { DateTime } from 'luxon';

const MailingTransactionsDrawer = () => {
    const currencySymbol = useCurrencySymbol();
    const { accountId, timezone } = useCurrentAccount();
    const { data: mailPiece } = useCurrentMailing();
    const transactions = mailPiece.transactions ?? [];

    return (
        <>
            <Drawer.Header>
                <Drawer.Title>Mailing transactions</Drawer.Title>
                <Drawer.Close />
            </Drawer.Header>
            <Drawer.Body>
                {transactions.map(transaction => (
                    <Box key={transaction.id} className={'flex gap-4 p-4'}>
                        <Avatar.Root>
                            <Avatar.Fallback
                                className={'border border-green-500 bg-green-100'}
                                aria-label="Check"
                            >
                                <FontAwesomeIcon className={'text-green-500'} icon={faCheck} />
                            </Avatar.Fallback>
                        </Avatar.Root>
                        <div className={'flex flex-grow items-center justify-between gap-4'}>
                            <div className={'flex flex-col'}>
                                <p className={'text-sm font-medium'}>
                                    {currencySymbol}
                                    {maskDecimal(transaction.amount)}
                                </p>
                                <Link
                                    className={'text-sm font-medium'}
                                    to={`/accounts/${accountId}/transactions/${transaction.id}`}
                                >
                                    View transaction
                                </Link>
                            </div>
                            <p className={'text-sm text-gray-500'}>
                                {rawDateFromServer(transaction.transacted_at)
                                    .setZone(timezone)
                                    .toLocaleString(DateTime.DATE_SHORT)}
                            </p>
                        </div>
                    </Box>
                ))}
            </Drawer.Body>
            <Drawer.Footer>
                <Drawer.Cancel>Cancel</Drawer.Cancel>
            </Drawer.Footer>
        </>
    );
};

export { MailingTransactionsDrawer };
